import { jsx } from 'react/jsx-runtime';
import { useDialogContext } from '@lemonade-hq/cdk';
import React, { useCallback, useMemo } from 'react';
import { AuADialog } from '../components/AuA/AuADialog.esm.js';
import { useUserContext } from './UserProvider.esm.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var AuAContext = /*#__PURE__*/ React.createContext({
    value: {
        isOpen: false
    },
    actions: {
        open: function() {},
        close: function() {}
    }
});
var AuAProvider = function(_param) {
    var children = _param.children, props = _object_without_properties(_param, [
        "children"
    ]);
    var user = useUserContext().user;
    var _useDialogContext = useDialogContext(), openDialog = _useDialogContext.openDialog, isOpen = _useDialogContext.isDialogOpen, close = _useDialogContext.closeDialog;
    var open = useCallback(function(overrideProps) {
        openDialog(/*#__PURE__*/ jsx(AuADialog, _object_spread({
            onClose: close,
            user: user
        }, props, overrideProps)));
    }, [
        close,
        openDialog,
        user,
        props
    ]);
    var value = useMemo(function() {
        return {
            value: {
                isOpen: isOpen,
                user: user
            },
            actions: {
                open: open,
                close: close
            },
            props: props
        };
    }, [
        isOpen,
        user,
        close,
        open,
        props
    ]);
    return /*#__PURE__*/ jsx(AuAContext.Provider, {
        value: value,
        children: children
    });
};
// eslint-disable-next-line @typescript-eslint/naming-convention
var useAuAContext = function() {
    return React.useContext(AuAContext);
};

export { AuAContext, AuAProvider, useAuAContext };
